/**
 * webapi 回應的資料格式
 */
export class ResBaseDTO<T> {
    [key: string]: any
    /**執行結果 */
    result: boolean
    /**回傳資料 */
    data: any
    /**執行訊息 */
    message?: string;
    /**錯誤訊息, 僅錯誤發生時顯示 */
    error?: string;
    /**是否有資料列 */
    hasRows?: boolean

    constructor(result?: boolean, data?: any) {
        this.result = result || false;
        this.data = data || null;
    }
}

/**
 * webapi 回應的資料格式: data類型
 */
export class ResByPageBaseDTO<T> {
    /**資料筆數 */
    'x-total-count': number
    /**資料回傳值 */
    'data-key': T[]
}
